import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BasePlugin } from './base-plugin.service';
import { AppConstants } from '../../utils/appConstants.class';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from './offlineApi.service';
import { map, filter } from 'rxjs/operators';
import { IDictionary } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PluginModelService extends BasePlugin {
  constructor(protected offlineApi?: OfflineApiService) {
    super();
  }

  public getPluginModels(): Observable<any> {
    const url = '/plugins/models/true';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.pluginModels);
  }

  public getPluginModel(pluginType: string): Observable<any> {
    const url = '/plugins/models/' + pluginType;
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.pluginModels, pluginType);
  }

  public getPluginModelsValidationSchemas(
    inspectionType: string,
    inspectionStatus: string
  ): Observable<IDictionary<any>> {
    const url = '/plugins/models/useInAll/true';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.pluginModels).pipe(
      map((pluginModels) => {
        return pluginModels
          .filter((p) => p.Validations)
          .reduce((acc, p) => {
            const schema = p.Validations.findLast((validation) => {
              return (
                validation.types &&
                (validation.types.includes(inspectionType) || validation.types.includes('*')) &&
                validation.statuses &&
                (validation.statuses.includes(inspectionStatus) || validation.statuses.includes('*'))
              );
            })?.ValidationSchema;

            const defaultSchema = p.Validations.findLast((validation) => {
              return validation.default;
            })?.ValidationSchema;

            if (schema || defaultSchema) {
              acc[p.PluginType] = schema ?? defaultSchema;
            }
            return acc;
          }, {});
      })
    );
  }
}
